<template>
  <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" />
</template>

<script>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  export default {
    components: {},
    setup() {
      const store = useStore();

      const refreshPage = (payload) => store.dispatch('getDevices', payload);

      const devices = computed(() => store.getters.devices);

      // table
      const structure = {
        title: 'Device',
        creationLink: {
          title: 'Nuovo',
          namePath: 'menu.device.devicesCreation',
        },
        data: [
          {
            title: 'imei',
            fields: [
              {
                placeholder: '@',
                name: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'imei',
              },
            ],
            span: 2,
            link: { idField: 'id', path: '/device/devices/:id' },
          },
          {
            title: 'sim imei',
            field: 'sim',
            subField: 'imei',
            span: 1,
          },
          {
            title: 'operatore',
            field: 'sim',
            subField: 'operator',
            span: 1,
          },
          {
            title: 'Proprietario sim',
            field: 'sim',
            subField: 'owner',
            span: 1,
          },
          {
            title: 'Configurazione',
            fields: [
              {
                placeholder: '@',
                name: 'configuration',
                subName: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'configuration',
                subName: 'name',
              },
            ],
            span: 2,
            link: {
              idField: 'id',
              subField: 'configuration',
              path: '/device/deviceConfigurations/details/:id',
            },
          },
        ],
      };

      return {
        data: devices,
        structure,
        refreshPage,
      };
    },
  };
</script>

<style></style>
